import React, { useEffect } from 'react';
import { selectors, useAppActions, useAppState } from 'store';
import { InitDataDrivenFiltersAction } from 'types';
import { PartitionOptionType } from '../types';

export type UseDataDrivenFiltersType = InitDataDrivenFiltersAction;

/**
 *  Handle the logic for the enterprise filters. It connects the UI with the store.
 * @param {UseDataDrivenFiltersType} param0
 * @returns
 */
const useDataDrivenFilters = ({
  onInit,
  onPartitionError,
  onPartitionSuccess,
}: UseDataDrivenFiltersType) => {
  const {
    initDataDrivenFilters,
    addPartition,
    removePartition,
    updatePartition,
  } = useAppActions();
  const dataDrivenFilters = useAppState(
    selectors.dataDrivenFilters.getSelectedPartitions
  );
  const { loading, error } = useAppState(selectors.dataDrivenFilters.getUI);
  const partitions = useAppState(selectors.dataDrivenFilters.getPartitions);
  const originalPartitions = useAppState(
    selectors.dataDrivenFilters.getOriginalPartitions
  );
  const selectedPartitions = useAppState(
    selectors.dataDrivenFilters.getSelectedPartitions
  );

  const partitionOptions = React.useMemo(
    () =>
      partitions.map((partition) => ({
        data: { partition },
        label: partition.Description,
        value: partition.PublicKey,
      })),
    [partitions]
  );

  const onAddDataDrivenFilter = () => {
    addPartition({});
  };

  const handleRemoveSource = (selectedPartitionIndex: number) => {
    removePartition({ selectedPartitionIndex });
  };

  const handleSourceSelected = (
    option: PartitionOptionType,
    selectedPartitionIndex: number
  ) => {
    updatePartition({
      ...option,
      selectedPartitionIndex,
    });
  };

  useEffect(() => {
    initDataDrivenFilters({ onInit, onPartitionError, onPartitionSuccess });
  }, []);

  return {
    dataDrivenFilters,
    partitionOptions,
    selectedPartitions,
    originalPartitions,
    loading,
    error,
    addDataDrivenFilter: onAddDataDrivenFilter,
    onRemoveSource: handleRemoveSource,
    onSourceSelected: handleSourceSelected,
  };
};

export default useDataDrivenFilters;
